import { ScreenHeader } from '@/components/layout/screen-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FriendsFeedTab } from '@/features/activity/components/friends-feed-tab';
import { NearbyFeedTab } from '@/features/activity/components/nearby-feed-tab';
import Ionicons from '@expo/vector-icons/Ionicons';
import { router } from 'expo-router';
import React from 'react';
import { Pressable, View } from 'react-native';

export function ActivityScreen() {
  return (
    <View className="flex-1">
      <ScreenHeader
        title="Activity"
        subtitle="See what people are eating"
        showMenuButton
        rightSlot={
          <Pressable
            onPress={() => router.push('/(root)/leaderboard')}
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            accessibilityRole="button"
            accessibilityLabel="Leaderboard"
          >
            <Ionicons name="trophy-outline" size={24} className="text-foreground" />
          </Pressable>
        }
      />
      <Tabs defaultValue="nearby" className="flex-1">
        <TabsList>
          <TabsTrigger value="nearby" title="Nearby" />
          <TabsTrigger value="friends" title="Friends" />
        </TabsList>
        <TabsContent value="nearby" className="flex-1">
          <NearbyFeedTab />
        </TabsContent>
        <TabsContent value="friends" className="flex-1">
          <FriendsFeedTab />
        </TabsContent>
      </Tabs>
    </View>
  );
}
